import { connect } from "react-redux";
import { withRouter } from 'react-router';
import { XS_MOBILE, SM_MOBILE, MD_TABLET, LG_TABLET } from "../../../../../constants/textConstants";
import { Button } from "../../../index";
import './heading_button_cta.scss';

const mapStateToProps = (state) => {
    return {
        screenBreakPoint: state.common.screenBreakPoint
    }
};

export const HeadingButtonCTA = withRouter(connect(mapStateToProps)(({
    history,
    label,
    onClick,
    to,
    screenBreakPoint,
}) => {

    const isMobile = ([XS_MOBILE, SM_MOBILE, MD_TABLET]).indexOf(screenBreakPoint) > -1 ? true : false;

    const handleOnClick = (e) => {

        if (to) {
            history.push(to);
        }

        if (onClick) {
            onClick(e);
        }
    };

    return (label && (onClick || to)
        ? <div className="mybswh-heading__button">
            <Button
                variant="secondary"
                fluid={isMobile ? true : false}
                onClick={handleOnClick}
            >
                {label}
            </Button>
        </div>
        : null
    )
}));